import { useRef } from 'react'
import { Checkbox } from 'shared/ui/Checkbox/Checkbox'
import { TableCell } from 'shared/ui/Table'
import { getAriaLabel } from 'shared/lib'

import styles from './styles.module.scss'

type ICheckboxCellProps = {
  isHeader?: boolean
  selected: boolean
  isIndeterminate?: boolean
  disabled?: boolean
  onChangeValue: (isSelected: boolean, isShiftKey: boolean) => void
  ariaLabel?: string
}

export const CheckboxCell = ({
  isHeader = false,
  selected,
  isIndeterminate,
  disabled,
  onChangeValue,
  ariaLabel,
}: ICheckboxCellProps) => {
  const isShiftKeyRef = useRef(false)

  const handleClick = (event: React.MouseEvent) => {
    isShiftKeyRef.current = event.shiftKey
  }

  const handleChange = (isSelected: boolean) => {
    onChangeValue(isSelected, isShiftKeyRef.current)
    isShiftKeyRef.current = false
  }

  return (
    <TableCell width='40px' minWidth='40px' isHeader={isHeader} className={styles.checkboxCell}>
      {() => (
        <div
          className={styles.wrapCheckbox}
          aria-label={getAriaLabel('Checkbox', ariaLabel)}
          onClickCapture={handleClick}
        >
          <Checkbox
            disabled={disabled}
            checked={selected}
            isIndeterminate={isIndeterminate}
            onChange={handleChange}
            ariaLabel='TableViewRow'
          />
        </div>
      )}
    </TableCell>
  )
}
